import ACTIONS from "../../constants/actions";

const initialState = {
	tracker      : false,
	tv           : false,
	video_online : false,
	sport        : {
		sportId : 0
	},
	league       : {
		id : 0
	},
	linePeriod   : 0,
};

export default function eventFilter(state = initialState, action) {
	switch ( action.type ) {
		case ACTIONS.FILTER.DATA:
			const type = action.filterType;
			if ( !(type in state) ) {
				return state;
			}

			let filter = Object.assign({}, state);
			switch ( type ) {
				case 'tv':
				case 'video_online':
				case 'tracker':
					filter[type] = !filter[type];
					break;
				case 'sport':
					filter[type] = action.data;
					filter['league'] = {id : 0};
					break;
				case 'league':
				case 'linePeriod':
					filter[type] = action.data;
					break;
			}
			return filter;
		case ACTIONS.FILTER.CLEAR:
			return initialState;
		default:
			break;
	}

	return state;
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/event-filter.js